"use client";
import {
  DateInputField
} from "./chunk-L4FOSONL.mjs";
import {
  DateInputGroup
} from "./chunk-YVBCSFY6.mjs";
import {
  useTimeInput
} from "./chunk-XJKRAFBB.mjs";

// src/time-input.tsx
import { forwardRef } from "@nextui-org/system";
import { jsx } from "react/jsx-runtime";
function TimeInput(props, ref) {
  const { state, slots, classNames, getBaseGroupProps, getInputProps, getFieldProps } = useTimeInput({
    ...props,
    ref
  });
  return /* @__PURE__ */ jsx(DateInputGroup, { ...getBaseGroupProps(), children: /* @__PURE__ */ jsx(
    DateInputField,
    {
      classNames,
      inputProps: getInputProps(),
      slots,
      state,
      ...getFieldProps()
    }
  ) });
}
TimeInput.displayName = "NextUI.TimeInput";
var time_input_default = forwardRef(TimeInput);

export {
  time_input_default
};
